/**
 * Storage for session information.
 */
import React, { useReducer, createContext } from "react";

export const SessionContext = createContext();

const initialState = {
  userid: 0, //Temp:1 //Default 0
  aid: 0,//Temp:1 //Default 0
  ident: '',  //Temp: Dx6zYzyvuTP4rXAGdu~z //Default ''
  isActive: false, //Temp:true  //Default false
  clientList: [],
  userList: [],
  clientRegister: [],
};


const reducer = (state, action) => {
  switch (action.type) {

    case "create":
      return { ...state, 
        userid: action.payload.userid,
        aid: action.payload.aid,
        isActive: action.payload.isActive,
        ident: action.payload.ident
      };
      case "end":
        return { ...state, 
          userid: 0,
          aid: 0,
          ident: '', 
          clientList: [],
          userList: [],
          clientRegister: [],
          isActive: false,
      };
      case "setClientRegister":
        return { ...state,
          clientRegister: action.payload.clientRegister,
      };
      case "setClientList":
        return { ...state,
          clientList: action.payload.clientList,
      };
      case "setUserList":
        return { ...state,
          userList: action.payload.userList,
      };
    default:
      throw new Error();
  }
};

export const SessionContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SessionContext.Provider value={[state, dispatch]}>
      {props.children}
    </SessionContext.Provider>
  );
};